let domain = 'dev.mb.prc.cloud';

let bucket = 'mb-dev-messages';

if (process.env.NODE_ENV === 'production') {
  domain = 'mb.prc.cloud';
  bucket = 'mb-prd-messages';
}

export const API_URL = `https://api.${domain}/v1`;

export const MESSAGES_ENDPOINT = '/messages';

export const DOWNLOAD = '/download';

export const VALIDATE_FILENAME = '/validate_filename';

export const LOGIN_ENDPOINT = '/auth';

export const AUDIO_URL = `https://s3.amazonaws.com/${bucket}`;

export const POST = 'POST';

export const PUT = 'PUT';

export const DELETE = 'DELETE';

/* IMPORTANT: when application is moved to another address inform PRC to point to new location.If not, they wont be able to match redrirect with src=messagebank.It's hardcoded on their end
              Current UI points to https://messagebank-1.dev.mb.prc.cloud.
*/
export const PRENTROM_CREATE_ACCOUT_URL = 'https://accounts.prc-saltillo.com/register';

export const PRENTROM_FORGOT_PASSWORD_URL = 'https://accounts.prc-saltillo.com/forgot-password';

export const TARGET_BLANK = '_blank';



// WEBPACK FOOTER //
// ./src/constants/api.js